import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsuarioEmpresaListarRoutingModule } from './usuario-empresa-listar-routing.module';
import { UsuarioEmpresaListarComponent } from './usuario-empresa-listar.component';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { ConfirmationService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessagesModule } from 'primeng/messages';


@NgModule({
  declarations: [
    UsuarioEmpresaListarComponent
  ],
  imports: [
    CommonModule,
    UsuarioEmpresaListarRoutingModule,
    TableModule,
    DividerModule,
    InputTextModule,
    ButtonModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    MessagesModule
  ],
  providers: [ConfirmationService]
})
export class UsuarioEmpresaListarModule { }
